import { SteemActionType } from '@popup/steem/actions/action-type.enum';
export const RpcSwitcherReducer = (state = { display: false }, { type, payload }) => {
    switch (type) {
        case SteemActionType.SET_SWITCH_TO_RPC:
            return Object.assign(Object.assign({}, state), { rpc: payload });
        case SteemActionType.SET_DISPLAY_SWITCH_RPC:
            return Object.assign(Object.assign({}, state), { display: payload });
        default:
            return state;
    }
};
